'use client'
import styles from './style.module.scss'
import { useEffect, useState } from 'react';
// import Nav from './nav';
import { BurgerMenu } from './burger/burger';
import { AnimatePresence } from 'framer-motion';
import { usePathname } from 'next/navigation';

export const  BurgerMenuWrapper =() => {

  const [isActive, setIsActive] = useState(false);
  const pathname = usePathname();

  useEffect( () => {
    if(isActive) setIsActive(false)
  }, [pathname])

console.log(isActive, 'active')

  return (
    <>
    <div className={styles.main}>

      <div className={styles.header}>
        <div onClick={() => {setIsActive(!isActive)}} className={styles.button}>
          <div className={`${styles.burger} ${isActive ? styles.burgerActive : ""}`}></div>
        </div>
      </div>

    </div>
    <AnimatePresence mode="wait">
      {isActive && <BurgerMenu />}
    </AnimatePresence>
    </>
  )
}